import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    minWidth: '0',
    overflow: 'hidden',
  },

  scroll: {
    flex: '1',
    overflowY: 'auto',
    minHeight: '0',
    paddingTop: tokens.spacingVerticalL,
    paddingRight: tokens.spacingHorizontalXL,
    paddingBottom: tokens.spacingVerticalXXL,
    paddingLeft: tokens.spacingHorizontalXL,
  },

  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground3,
    paddingBottom: tokens.spacingVerticalM,
  },

  breadcrumbLink: {
    color: tokens.colorNeutralForeground2,
    textDecorationLine: 'none',
    ':hover': {
      textDecorationLine: 'underline',
      color: tokens.colorNeutralForeground1,
    },
  },

  breadcrumbCurrent: {
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightSemibold,
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalL,
  },

  subtitle: {
    color: tokens.colorNeutralForeground3,
  },

  cards: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },

  card: {
    paddingTop: tokens.spacingVerticalL,
    paddingRight: tokens.spacingHorizontalL,
    paddingBottom: tokens.spacingVerticalL,
    paddingLeft: tokens.spacingHorizontalL,
    backgroundColor: tokens.colorNeutralBackground1,
    borderTopWidth: '1px',
    borderRightWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke2,
    borderRightColor: tokens.colorNeutralStroke2,
    borderBottomColor: tokens.colorNeutralStroke2,
    borderLeftColor: tokens.colorNeutralStroke2,
    borderRadius: tokens.borderRadiusMedium,
  },

  cardLabel: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    letterSpacing: '0.04em',
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase',
    paddingBottom: tokens.spacingVerticalS,
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },

  cardLabelHelp: {
    textTransform: 'none',
    letterSpacing: 'normal',
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground3,
  },

  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },

  // Horizontal row of form fields. Fluent v9 has no Stack/Flex component, so we
  // use flexbox directly. Children get `fieldColumn`; controls get
  // `fullWidthInput` / `fullWidthTextarea` (applied directly — no descendant
  // selectors) so paired fields are equal width and inputs fill their column.
  fieldRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: tokens.spacingHorizontalL,
    width: '100%',
  },

  // Equal-width, responsive column. flex-basis 0 + grow makes every column the
  // same width regardless of content; minWidth lets columns wrap on narrow
  // screens instead of crushing.
  fieldColumn: {
    flexGrow: 1,
    flexBasis: 0,
    minWidth: '200px',
  },

  fullWidthInput: {
    width: '100%',
  },

  fullWidthTextarea: {
    width: '100%',
  },

  errorText: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeBase200,
  },

  footer: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalL,
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke2,
  },

  // Strips default <fieldset> chrome and flows children into the parent grid.
  // The element is kept so `disabled` cascades to nested controls in view mode.
  fieldsetReset: {
    display: 'contents',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    borderLeftStyle: 'none',
    paddingTop: '0',
    paddingRight: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0',
  },
});
